import {
  Component,
  Renderer2,
} from "@angular/core";
import { AbstractControl, ReactiveFormsModule } from "@angular/forms";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {
  FormGroup,
  FormsModule,
  Validators,
  FormBuilder,

} from "@angular/forms";
import { NgClass, NgStyle } from "@angular/common";
import { InventoryService } from "src/app/service/inventory.service";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {
  alertModalDelete,
  alertModalWithoutConfirm,
  alertModal,
} from "src/app/component/helpers/alert";
import { readBlobError, saveBlob } from "src/app/component/helpers/helper";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from '@angular/router';
import { NoDataComponent } from "../shared/no-data/no-data.component";
import { environment } from "src/environments/environment";
import { SORT_BY, SORT_ORDER } from "src/app/constants/inventory.constant";
import { AssetHistoryComponent } from "../shared/asset-history/asset-history.component";
import { canViewAssetLogs } from "src/app/service/asset-logs.service";


interface Category {
  value: string;
  viewValue: string;
}


import { isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
  selector: "app-inventories",
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    NgStyle,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    ZXingScannerModule,
    InfiniteScrollModule,
    NoDataComponent,
    MatAutocompleteModule,
    AssetHistoryComponent
  ],
  templateUrl: "./inventories.component.html",
  styleUrls: ["./inventories.component.css", "../styles/inventory.css"]
})
export class InventoriesComponent {
  canViewAssetLogs = false;
  activeDetailTab: 'details' | 'history' = 'details';
  duplicateProductIdError: string = "";
  originalProductId: string = "";
  assignedProductId: string = "";
  // Mobile scanner // REVIEW
  scannerEnabled: boolean = false;
  scannedProductName: string = "";
  scannedProductId: string = "";

  openScannerModal() {
    this.scannerEnabled = true;
    const modalElement = document.getElementById("qrScannerModal");
    if (modalElement) {
      modalElement.classList.add("show");
      modalElement.style.display = "block";
      modalElement.style.backgroundColor = "rgba(0,0,0,0.5)";
    }
  }

  closeScannerModal() {
    this.scannerEnabled = false;
    const modalElement = document.getElementById("qrScannerModal");
    if (modalElement) {
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
    }
  }

  openModal() {
    const modalElement = document.getElementById("exampleModalCenter");
    if (modalElement) {
      this.renderer.addClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "block");
    }
  }

  closeModal() {
    const modalElement = document.getElementById("exampleModalCenter");
    if (modalElement) {
      this.renderer.removeClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "none");
    }
  }

  noWhitespaceValidator(
    control: AbstractControl
  ): { [key: string]: any } | null {
    const isWhitespace = (control.value || "").trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  optionalNoWhitespaceValidator = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    if (!control.value || control.value.length === 0) {
      return null;
    }
    const isWhitespace = (control.value || "").trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  };

  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5]);

  categories: Category[] = [
    { value: "Drone", viewValue: "Drone" },
    { value: "Drone helipad", viewValue: "Drone helipad" },
    { value: "Battery", viewValue: "Battery" },
    { value: "Power Bank", viewValue: "Power Bank" },
    { value: "Graphic card", viewValue: "Graphic card" },
    { value: "Laptop", viewValue: "Laptop" },
    { value: "Mouse", viewValue: "Mouse" },
    { value: "Keyboard", viewValue: "Keyboard" },
    { value: "Earphone", viewValue: "Earphone" },
    { value: "Screen", viewValue: "Screen" },
    { value: "CPU", viewValue: "CPU" },
    { value: "RAM", viewValue: "RAM" },
    { value: "Hard Disk", viewValue: "Hard Disk" },
    { value: "HDMI To HDMI", viewValue: "HDMI To HDMI" },
    { value: "HDMI To Display Cable", viewValue: "HDMI To Display Cable" },
    { value: "OREI HDMI", viewValue: "OREI HDMI" },
    { value: "HDMI To MICRO HDMI", viewValue: "HDMI To MICRO HDMI" },
    { value: "HDMI To MINI HDMI", viewValue: "HDMI To MINI HDMI" },
    { value: "HDMI To VGI", viewValue: "HDMI To VGI" },
    {
      value: "4k Video Capture HDMI To USB",
      viewValue: "4k Video Capture HDMI To USB",
    },
    { value: "USB HUB", viewValue: "USB HUB" },
    {
      value: "TP link WIFI USB adaptor",
      viewValue: "TP link WIFI USB adaptor",
    },
    { value: "Oculus", viewValue: "Oculus" },
    { value: "Oculus sensor", viewValue: "Oculus sensor" },
    { value: "Oculus GO", viewValue: "Oculus GO" },
    { value: "INSTA 360", viewValue: "INSTA 360" },
    { value: "Extension", viewValue: "Extension" },
    { value: "Monitor", viewValue: "Monitor" },
    { value: "BENQ PENS", viewValue: "BENQ PENS" },
    { value: "Bosch Kit", viewValue: "Bosch Kit" },
    { value: "Charger + Cable", viewValue: "Charger + Cable" },
    { value: "Oculus Quest", viewValue: "Oculus Quest" },
    { value: "Security Camera", viewValue: "Security Camera" },
    { value: "Cable", viewValue: "Cable" },
    { value: "Touch Cable", viewValue: "Touch Cable" },
    { value: "USB Extension", viewValue: "USB Extension" },
    { value: "DVI To VGA", viewValue: "DVI To VGA" },
    { value: "Mira cast Dongle", viewValue: "Mira cast Dongle" },
    { value: "HDMI To SDI Card", viewValue: "HDMI To SDI Card" },
    { value: "Measure Tape", viewValue: "Measure Tape" },
    { value: "Board Clip", viewValue: "Board Clip" },
    { value: "Mini Tripod", viewValue: "Mini Tripod" },
    { value: "Mini Blower", viewValue: "Mini Blower" },
    { value: "Touch bar", viewValue: "Touch bar" },
    { value: "Smart Tv Box", viewValue: "Smart Tv Box" },
    {
      value: "Coller master 750 Box 650 SMPS",
      viewValue: "Coller master 750 Box 650 SMPS",
    },
    { value: "Jio Hotspot", viewValue: "Jio Hotspot" },
    { value: "Fire Tv stick", viewValue: "Fire Tv stick" },
    { value: "Fleet track device", viewValue: "Fleet track device" },
    { value: "Xbox Kinect + Aaptor", viewValue: "Xbox Kinect + Aaptor" },
    { value: "Charger", viewValue: "Charger" },
    { value: "Decklink HDMI Recorder", viewValue: "Decklink HDMI Recorder" },
    { value: "KVM Orie Adaptor", viewValue: "KVM Orie Adaptor" },
    { value: "KVM Orie USB 2.0", viewValue: "KVM Orie USB 2.0" },
    { value: "CORSAIR -VS 650", viewValue: "CORSAIR -VS 650" },
    { value: "VR MASK 150", viewValue: "VR MASK 150" },
    { value: "3D Advertising machine", viewValue: "3D Advertising machine" },
    { value: "HP IP Camera", viewValue: "HP IP Camera" },
    { value: "Intra Oral Camera", viewValue: "Intra Oral Camera" },
    { value: "Mini Keyboard", viewValue: "Mini Keyboard" },
    { value: "Headphones", viewValue: "Headphones" },
    { value: "Gaming remote", viewValue: "Gaming remote" },
    { value: "3D Demo car", viewValue: "3D Demo car" },
    { value: "Green screen", viewValue: "Green screen" },
    { value: "Router", viewValue: "Router" },
  ];

  currentStep = 1;
  selectedImage: File | null = null;
  selectedImages: File[] = [];
  previewImageUrl: string | ArrayBuffer | null = null;
  previewImagesUrl: string[] = [];
  maxImages: number = 5;

  productForm: FormGroup;
  batteryForm: FormGroup;
  warrantyForm: FormGroup;
  qrForm: FormGroup;

  //To enable disable the warranty Form
  isWarrantyEnabled: boolean = false;
  isStorageEnabled: boolean = true;
  qrVisible = false;
  batteryFormVisible = false;
  warrantyFormVisible = false;
  productFormVisible: boolean;

  showConditionReason: boolean = false;
  showRentedDate: boolean = false;

  // recharge Cycle Dropdown
  numbers: number[] = Array.from({ length: 100 }, (_, i) => i + 1);
  userDepartment: string | null = null;
  showInventoryButton = false;

  users: { value: string; viewValue: string; id: string }[] = [];
  isFormSubmitting: boolean = false;
  selectedInventoryIds = new Set<string>();
  isExportingBarcodes = false;
  constructor(
    private fb: FormBuilder,
    private inventoryService: InventoryService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    //sorting categories by alphabetical order
    this.categories.sort((a, b) => a.viewValue.localeCompare(b.viewValue));

    // Product Info Form
    this.productForm = this.fb.group({
      assetName: [
        "",
        [
          Validators.required,
          Validators.maxLength(50),
          this.noWhitespaceValidator,
        ],
      ],
      productId: [
        "",
        [
          Validators.maxLength(25),
          this.optionalNoWhitespaceValidator,
        ],
      ],
      location: [
        "",
        [
          Validators.required,
          Validators.maxLength(50),
          this.noWhitespaceValidator,
        ],
      ],
      type: ["", Validators.required],
      productCost: ["", Validators.required],
      accessoriesInv: ["", [Validators.maxLength(50)]],
      assignTo: [[]],
      rentedDate: [""],
      productFile: [],
    });
    this.onTypeChange({
      target: { value: this.productForm.get("type")?.value },
    });

    //Battery Info Form
    this.batteryForm = this.fb.group({
      batteryType: ["", Validators.required],
      storageValue: [
        "",
        [
          Validators.required,
          Validators.maxLength(50),
          this.noWhitespaceValidator,
        ],
      ],
      storageType: ["", Validators.required],
      recharge: this.fb.group({
        number: ["1", this.showRechargeCycle ? Validators.required : ""],
        cycle: ["days", this.showRechargeCycle ? Validators.required : ""],
      }),
      assetCategory: ["Drone", Validators.required],
      brand: [
        "",
        [
          Validators.required,
          Validators.maxLength(100),
          this.noWhitespaceValidator,
        ],
      ],
      quantity: ["", Validators.required],
      size: [
        "",
        [
          Validators.required,
          Validators.maxLength(50),
          this.noWhitespaceValidator,
        ],
      ],
    });

    //Warranty Info Form
    this.warrantyForm = this.fb.group({
      warranty: ["", Validators.required],
      expiryDate: [{ value: "", disabled: false }],
      contactPerson: [{ value: "", disabled: false }],
      phoneNumber: [{ value: "", disabled: false }],
      invoice: [{ value: "", disabled: false }],
    });

    this.qrForm = this.fb.group({
      barcode: ["", Validators.required],
    });
  }
  today: string;
  selectedFilter: string = 'all';
  filteredCategories: any[] = [];
  isCreating: boolean = false;

  selectedSort: string = 'newest';
  sortBy: SORT_BY = SORT_BY.CREATED_AT;
  sortOrder: SORT_ORDER = SORT_ORDER.DESC;
  SORT_BY = SORT_BY;
  SORT_ORDER = SORT_ORDER;

  onSortDropdownChange(sortType: string): void {
    this.selectedSort = sortType;
    if (sortType === 'newest') {
      this.sortBy = SORT_BY.CREATED_AT;
      this.sortOrder = SORT_ORDER.DESC;
    } else if (sortType === 'oldest') {
      this.sortBy = SORT_BY.CREATED_AT;
      this.sortOrder = SORT_ORDER.ASC;
    } else if (sortType === 'ascName') {
      this.sortBy = SORT_BY.NAME;
      this.sortOrder = SORT_ORDER.ASC;
    } else if (sortType === 'descName') {
      this.sortBy = SORT_BY.NAME;
      this.sortOrder = SORT_ORDER.DESC;
    } else if (sortType === 'dateModified') {
      this.sortBy = SORT_BY.UPDATED_AT;
      this.sortOrder = SORT_ORDER.DESC;
    }
    if (!this.isAssigned && !this.myAssigned) {
      this.getInventoryData(true);
    } else if (this.isAssigned) {
      this.getAssignedInventory(true);
    } else if (this.myAssigned) {
      this.getOnlyAssignedInventory();
    }
  }

  onFilterDropdownChange(filter: string): void {
    this.selectedFilter = filter;
    if (filter === 'all') {
      this.getInventoryData(true);
    } else if (filter === 'assigned') {
      this.getAssignedInventory(true);
    } else if (filter === 'onlyAssigned') {
      this.getOnlyAssignedInventory();
    } else {
      this.getInventoryData(true, filter);
    }
  }

  onSort(sortField: SORT_BY): void {
    if (this.sortBy === sortField) {
      this.sortOrder = this.sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
    } else {
      this.sortBy = sortField;
      this.sortOrder = SORT_ORDER.DESC;
    }
    if (this.sortBy === SORT_BY.CREATED_AT && this.sortOrder === SORT_ORDER.DESC) {
      this.selectedSort = 'newest';
    } else if (this.sortBy === SORT_BY.CREATED_AT && this.sortOrder === SORT_ORDER.ASC) {
      this.selectedSort = 'oldest';
    } else if (this.sortBy === SORT_BY.NAME && this.sortOrder === SORT_ORDER.ASC) {
      this.selectedSort = 'ascName';
    } else if (this.sortBy === SORT_BY.NAME && this.sortOrder === SORT_ORDER.DESC) {
      this.selectedSort = 'descName';
    } else if (this.sortBy === SORT_BY.UPDATED_AT && this.sortOrder === SORT_ORDER.DESC) {
      this.selectedSort = 'dateModified';
    } else {
      this.selectedSort = '';
    }
    if (!this.isAssigned && !this.myAssigned) {
      this.getInventoryData(true);
    } else if (this.isAssigned) {
      this.getAssignedInventory(true);
    } else if (this.myAssigned) {
      this.getOnlyAssignedInventory();
    }
  }
  ngOnInit() {
    this.getAllUsers();
    this.getInventoryData();

    this.route.queryParams.subscribe((params) => {
      const filterType = params['filter'];

      if (filterType === 'onlyAssigned') {
        this.selectedFilter = 'onlyAssigned';
        this.getOnlyAssignedInventory();
      }
    });

    // this.getAssignInventory();
    // this.getAssignedInventory();
    this.batteryForm.valueChanges.subscribe((val) => console.log(val));
    this.userDepartment = localStorage.getItem("department");
    this.canViewAssetLogs = canViewAssetLogs();
    this.showInventoryButton =
      isHrOrItAdminDept(this.userDepartment) ||
      this.userDepartment === "ADMIN" ||
      this.userDepartment === "OPERATIONS" || this.userDepartment === "OFFICE ADMIN";

    const now = new Date();
    this.today = now.toISOString().split("T")[0];


    this.filteredCategories = this.categories;
    this.batteryForm.get('assetCategory')!.valueChanges.subscribe(val => {
      this.filteredCategories = this._filterCategories(val);
    });
  }

  displayCategory = (value: any): string => {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      const match = this.categories.find(cat => cat.value === value);
      return match ? match.viewValue : value;
    }

    if (typeof value === 'object' && value.value) {
      return value.viewValue || value.value;
    }

    return '';
  };


  private _filterCategories(value: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return this.categories.filter(option =>
      option.viewValue.toLowerCase().includes(filterValue)
    );
  }

  isDeleteModal: boolean = false;
  openDeleteModa() {
    console.log("clicked");
    this.isDeleteModal = true;
  }

  isSpinnerLoader: boolean = false;
  uploadFile(file: File) {
    console.log("Uploading file:", file);
    this.isSpinnerLoader = true;
    const formData = new FormData();
    formData.append("file", file);

    this.inventoryService.uploadInventory(formData).subscribe({
      next: (response: any) => {
        this.isSpinnerLoader = false;
        this.getInventoryData(true);

        const totalAdded = response?.data?.totalAdded || 0;
        const totalExisting = response?.data?.totalExisting || 0;
        const addedProductIds: string[] = response?.data?.addedProductIds || [];
        const existingProductIds: string[] = response?.data?.existingProductIds || [];

        let summary = `Total added: ${totalAdded}.`;
        if (addedProductIds.length > 0) {
          const sampleAdded = addedProductIds.slice(0, 5).join(", ");
          summary += ` Created IDs: ${sampleAdded}${addedProductIds.length > 5 ? ` (+${addedProductIds.length - 5} more)` : ""}.`;
        }
        if (totalExisting > 0) {
          const sampleExisting = existingProductIds.slice(0, 5).join(", ");
          summary += ` Skipped duplicates (${totalExisting}): ${sampleExisting}${existingProductIds.length > 5 ? ` (+${existingProductIds.length - 5} more)` : ""}.`;
        }

        setTimeout(() => {
          window.location.reload();
        }, 4000);

        if (totalAdded === 0 && totalExisting > 0) {
          alertModalWithoutConfirm(
            "warning",
            `No new items added. ${totalExisting} existing product(s) skipped: ${existingProductIds.slice(0, 5).join(", ")}${existingProductIds.length > 5 ? "..." : ""}`
          );
        } else if (totalAdded === 0 && totalExisting === 0) {
          alertModalWithoutConfirm("success", "Successfully Imported!");
        } else {
          alertModalWithoutConfirm("success", `Bulk Upload Complete! ${summary}`);
        }
      },
      error: (error) => {
        this.isSpinnerLoader = false;
        console.error("Upload failed:", error);
        const message = error?.error?.message || "Inventory upload failed!";
        alertModalWithoutConfirm("warning", message);
      }
    });
  }


  importData() {
    console.log("importData");
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".xlsx";
    fileInput.addEventListener("change", (event) => {
      const target = event.target as HTMLInputElement;

      if (target.files && target.files.length > 0) {
        const file: File = target.files[0];

        const fileNameParts = file.name.split(".");
        const fileExtension =
          fileNameParts[fileNameParts.length - 1].toLowerCase();

        if (fileExtension === "xlsx") {
          this.uploadFile(file);
          // alertModal("success", "Inventory Uploaded Successfully!");
        } else {
          alertModalWithoutConfirm(
            "error",
            "Invalid file format. Please select a .xlsx file."
          );
        }
      } else {
        alertModalWithoutConfirm(
          "warning",
          "No file selected. Please choose a file to upload."
        );
      }
    });

    fileInput.click();
  }



  formatDate(isoString: string): string {
    const date = new Date(isoString);

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    };

    return date.toLocaleDateString('en-US', options);
  }

  assigned = [];
  totalAssigned: number = 0;
  isAssigned: Boolean = false;
  getAssignedInventory(reset = false, assignedToUser?: string) {
    if (reset) {
      this.currentPageNume = 1;
      this.assigned = [];
    }

    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
    };

    const targetUser =
      assignedToUser ||
      (this.selectedFilter !== 'all' &&
        this.selectedFilter !== 'assigned' &&
        this.selectedFilter !== 'onlyAssigned'
        ? this.selectedFilter
        : undefined);
    if (targetUser) {
      field.assignedTo = targetUser;
    }

    this.inventoryService.getAssigned(field).subscribe((res: any) => {
      const newItems = res?.data?.records || [];

      if (this.currentPageNume === 1) {
        this.assigned = [...newItems];
      } else {
        this.assigned = [...this.assigned, ...newItems];
      }

      this.totalAssigned = res?.data?.totalCounts || 0;
      this.isAssigned = true;
      this.myAssigned = false;
      this.isAllInventory = false;
    });
  }


  searchAssignedQuery: any;
  searchedAssignedInventory = [];
  totalAssignedSearchedInv: any;
  onSearchAssignedInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalAssigned || 50,
      searchQuery: this.searchAssignedQuery,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
    };
    if (
      this.selectedFilter !== 'all' &&
      this.selectedFilter !== 'assigned' &&
      this.selectedFilter !== 'onlyAssigned'
    ) {
      field.assignedTo = this.selectedFilter;
    }
    if (this.searchAssignedQuery === "") {
      this.clearAssignedSearch();
    } else {
      this.inventoryService.getAssignInv(field).subscribe((response: any) => {
        console.log(response);
        this.searchedAssignedInventory = response?.["data"]?.records || [];
        this.assigned = this.searchedAssignedInventory;
        this.totalAssignedSearchedInv = response?.["data"]?.totalCounts || 0;
        this.totalAssigned = this.totalAssignedSearchedInv;
      });
    }
  }

  clearAssignedSearch() {
    this.searchAssignedQuery = "";
    this.searchedAssignedInventory = [];
    this.assigned = [];
    this.currentPageNume = 1;
    this.getAssignedInventory(true);
  }

  ownAssigned: any[] = [];
  myAssigned: Boolean = false;
  totalMyAssigned: number = 0;
  getOnlyAssignedInventory() {
    this.currentPageNume = 1;
    this.ownAssigned = [];
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
    };
    this.inventoryService.getAssignInv(field).subscribe((res: any) => {
      const newItems = res.data.records || [];

      if (this.currentPageNume === 1) {
        this.ownAssigned = [...newItems];
      } else {
        this.ownAssigned = [...this.ownAssigned, ...newItems];
      }
      // this.ownAssigned = res["data"].records;
      this.totalMyAssigned = res["data"].totalCounts;
      this.myAssigned = true;
      this.isAssigned = false;
      console.log("Assigned", res);
    });
  }

  searchMyAssignedQuery: any;
  searchedMyAssignedInventory = [];
  totalMyAssignedSearchedInv: any;
  onSearchMyAssignedInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalMyAssigned,
      searchQuery: this.searchMyAssignedQuery,
    };
    if (this.searchMyAssignedQuery === "") {
      this.clearMyAssignedSearch();
    } else {
      this.inventoryService.getAssignInv(field).subscribe((response) => {
        console.log(response);
        this.searchedMyAssignedInventory = response["data"].records;
        this.ownAssigned = this.searchedMyAssignedInventory;
        this.totalMyAssignedSearchedInv = response["data"].totalCounts;
        this.totalMyAssigned = this.totalMyAssignedSearchedInv;
      });
    }
  }

  clearMyAssignedSearch() {
    this.searchMyAssignedQuery = "";
    this.searchedMyAssignedInventory = [];
    this.ownAssigned = [];
    this.currentPageNume = 1;
    this.getOnlyAssignedInventory();
  }

  patchExpiryDate(date: string): string {
    const parsedDate = new Date(date);
    console.log("Parsed Date", parsedDate)
    const year = parsedDate.getFullYear();
    const month = ("0" + (parsedDate.getMonth() + 1)).slice(-2);
    const day = ("0" + parsedDate.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  onQuantityInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value === '0' || +input.value < 1) {
      input.value = '';
    }
  }


  isEditable: boolean = false;
  // Edit product
  editProduct() {
    this.currentStep = 1;
    this.isEdit = true;
    this.originalProductId = this.singleInventory.productId || "";
    this.duplicateProductIdError = "";
    const rentedTillDate = this.patchExpiryDate(this.singleInventory.rentedTill);
    const accessoryNames = this.singleInventory.accessories
      .map((item: { name: string }) => item.name)
      .join(",");
    // Product Form Patching Values
    this.productForm.patchValue({
      assetName: this.singleInventory.name,
      productId: this.singleInventory.productId,
      location: this.singleInventory.location,
      type: this.singleInventory.type,
      productCost: this.singleInventory.cost,
      accessoriesInv: accessoryNames,
      rentedDate: rentedTillDate,
      productFile: this.singleInventory.images,
    });
    console.log("Accessories", this.singleInventory.accessories);

    this.selectedImages = [];
    // Image Preview
    if (this.singleInventory.images && this.singleInventory.images.length > 0) {
      this.selectedImages = this.singleInventory.images;
      this.updateImagePreviews();
    }

    // Rental type enable
    this.showRentedDate = this.singleInventory.type === "Rental";
    const rentedDateControl = this.productForm.get("rentedDate");
    if (this.showRentedDate) {
      rentedDateControl?.setValidators([Validators.required]);
    } else {
      rentedDateControl?.clearValidators();
      rentedDateControl?.setValue("");
    }
    rentedDateControl?.updateValueAndValidity();
    console.log("Images", this.singleInventory.images);

    // Battery Form Patching Values
    this.batteryForm.patchValue({
      batteryType: this.singleInventory.batteryType,
      storageType: this.singleInventory.haveStorage ? "yes" : "No",
      assetCategory: this.singleInventory.assetCategory,
      brand: this.singleInventory.brand,
      quantity: this.singleInventory.quantity,
      size: this.singleInventory.size,
    });
    //Battery Type Enable
    this.showRechargeCycle = this.singleInventory.batteryType === "Chargeable";
    if (this.showRechargeCycle) {
      this.batteryForm.patchValue({
        recharge: {
          number: this.singleInventory.rechargeCycle,
          cycle: "Days",
        },
      });
    }
    const rechargeControl = this.batteryForm.get("recharge");
    if (!this.showRechargeCycle) {
      rechargeControl?.clearValidators();
    } else {
      rechargeControl?.setValidators([Validators.required]);
    }
    rechargeControl?.updateValueAndValidity();

    this.isStorageEnabled =
      this.singleInventory.haveStorage === true ||
      this.singleInventory.selectedStorage === "yes";
    if (this.isStorageEnabled) {
      this.batteryForm.patchValue({
        storageValue: this.singleInventory.storageVolume,
      });
      this.batteryForm.get("storageValue")?.enable();
    } else {
      this.batteryForm.patchValue({
        storageValue: "",
      });
      this.batteryForm.get("storageValue")?.disable();
    }

    // Warranty Form Patching Values
    if (this.singleInventory.haveWarranty && this.singleInventory.warranty) {
      const expiryDateISO = this.patchExpiryDate(
        this.singleInventory.warranty.expiryDate
      );

      const invoiceFile = this.singleInventory.warranty.invoice;
      console.log("InvoiceFile", invoiceFile);

      this.warrantyForm.patchValue({
        warranty: "yes",
        expiryDate: expiryDateISO,
        contactPerson: this.singleInventory.warranty.contactPerson,
        phoneNumber: this.singleInventory.warranty.phoneNumber,
        invoice: invoiceFile,
      });

      console.log("Expiry", expiryDateISO);
      this.isWarrantyEnabled = true;
      this.warrantyForm.get("expiryDate")?.enable();
      this.warrantyForm.get("contactPerson")?.enable();
      this.warrantyForm.get("phoneNumber")?.enable();
      this.warrantyForm.get("invoice")?.enable();
      if (invoiceFile) {
        this.loadInvoicePreview(invoiceFile);
      }
    } else {
      this.warrantyForm.patchValue({
        warranty: "No",
        expiryDate: null,
        contactPerson: "",
        phoneNumber: "",
        invoice: null,
      });
      this.isWarrantyEnabled = false;
      this.warrantyForm.get("expiryDate")?.disable();
      this.warrantyForm.get("contactPerson")?.disable();
      this.warrantyForm.get("phoneNumber")?.disable();
      this.warrantyForm.get("invoice")?.disable();
    }
    console.log("Warranty Enabled:", this.isWarrantyEnabled);
  }

  loadInvoicePreview(invoiceFileUrl: string): void {
    if (
      invoiceFileUrl.endsWith(".png") ||
      invoiceFileUrl.endsWith(".jpg") ||
      invoiceFileUrl.endsWith(".jpeg")
    ) {
      this.imagePreviewUrl = invoiceFileUrl;
      this.pdfPreviewUrl = null;
      this.filePreviewUrl = null;
    } else if (invoiceFileUrl.endsWith(".pdf")) {
      this.pdfPreviewUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(invoiceFileUrl);
      this.imagePreviewUrl = null;
      this.filePreviewUrl = null;
    } else {
      this.filePreviewUrl = invoiceFileUrl;
      this.imagePreviewUrl = null;
      this.pdfPreviewUrl = null;
    }
  }

  editInventoryId: string;
  singleInventory: any;
  getSingleInventory(id: any) {
    this.editInventoryId = id;
    this.inventoryService.getInventoryById(id).subscribe((res) => {
      this.singleInventory = res["data"];
      console.log("Inventory BY ID", this.singleInventory);
      if (this.singleInventory) {
        this.editProduct();
      }
    });
  }

  // Delete Inventory
  deleteInventory(id: any) {
    this.editInventoryId = id;
    this.inventoryService.deleteInventory(id).subscribe(
      (res) => {
        this.isDeleteModal = false;

        const modalEl = document.getElementById('deleteProduct');
        if (modalEl) {
          modalEl.classList.remove('show');
          modalEl.setAttribute('aria-hidden', 'true');
          modalEl.style.display = 'none';
        }

        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');

        alertModal("success", "Deleted successfully");
        this.getInventoryData();
      },
      (error) => {
        console.error(error);
        const message = error.error.message || "Something went wrong!";
        alertModalDelete(message);
      }
    );
  }



  //Product Condition Change
  onConditionChange(event: any): void {
    const conditionValue = event.target.value;
    this.showConditionReason = conditionValue === "Not Working";
    if (!this.showConditionReason) {
      this.productForm.get("conditionReason")?.setValue("");
    }
  }

  //Battery Type Change
  showRechargeCycle: boolean = false;
  onBatteryTypeChange(event: any): void {
    const batteryTypeValue = event.target.value;
    this.showRechargeCycle = batteryTypeValue === "Chargeable";
    if (!this.showRechargeCycle) {
      console.log({ showRechargeCycle: this.showRechargeCycle });

    }
  }

  onStorageTypeChange(event: any): void {
    const selectedStorage = event.target.value;
    this.isStorageEnabled = selectedStorage === "yes";

    if (this.isStorageEnabled) {
      this.batteryForm.get("storageValue")?.enable();
    } else {
      this.batteryForm.get("storageValue")?.disable();
    }
  }

  onWarrantyTypeChange(event: any): void {
    console.log("Before change, isEdit: ", this.isEdit);
    const selectedWarranty = event.target.value;
    this.isWarrantyEnabled = selectedWarranty === "yes";
    console.log("Warranty enabled:", this.isWarrantyEnabled);

    if (this.isWarrantyEnabled) {
      this.warrantyForm.get("expiryDate")?.enable();
      this.warrantyForm.get("contactPerson")?.enable();
      this.warrantyForm.get("phoneNumber")?.enable();
      this.warrantyForm.get("invoice")?.enable();
    } else {
      this.warrantyForm.get("expiryDate")?.disable();
      this.warrantyForm.get("contactPerson")?.disable();
      this.warrantyForm.get("phoneNumber")?.disable();
      this.warrantyForm.get("invoice")?.disable();

      this.warrantyForm.patchValue({
        expiryDate: null,
        contactPerson: "",
        phoneNumber: "",
        invoice: "",
      });
    }
  }

  //Product Type Change
  onTypeChange(event: any): void {
    const typeValue = event.target.value;
    this.showRentedDate = typeValue === "Rental";

    const rentedDateControl = this.productForm.get("rentedDate");
    if (this.showRentedDate) {
      rentedDateControl?.setValidators([Validators.required]);
    } else {
      rentedDateControl?.clearValidators();
      rentedDateControl?.setValue("");
    }
    rentedDateControl?.updateValueAndValidity();
  }


  // Remove multiple uploaded Image
  removeMultipleImage(index: number): void {
    const removedImage = this.selectedImages[index];

    if (this.isEdit && typeof removedImage === 'string') {
      const body = {
        inventoryId: this.editInventoryId,
        images: [removedImage],
      };

      this.inventoryService.deleteInventoryImage(body).subscribe(
        (response) => {
          console.log('Image removed successfully from server:', response);
          this.removeMultipleImageLocally(index);
        },
        (error) => {
          console.error('Failed to remove image from server', error);
          this.removeMultipleImageLocally(index);
        }
      );
    } else {
      this.removeMultipleImageLocally(index);
    }
  }

  removeMultipleImageLocally(index: number): void {
    this.selectedImages.splice(index, 1);
    this.updateImagePreviews();
    this.productForm.patchValue({
      productFile: this.selectedImages,
    });
  }

  submitted = false;
  //Product submit
  onSubmitProduct(): void {
    console.log(this.productForm);
    this.submitted = true;

    if (this.productForm.valid) {
      this.currentStep = 2;
      const formData = new FormData();
      Object.keys(this.productForm.value).forEach((key) => {
        formData.append(key, this.productForm.value[key]);
      });

      if (this.selectedImages.length > 0) {
        this.selectedImages.forEach((image, index) => {
          formData.append(`files[${index}]`, image);
        });
      }
    } else if (this.productForm.invalid) {
      console.log("invalid");
      return alertModalWithoutConfirm(
        "warning",
        "Please fill in all required fields before submitting."
      );
    }
  }

  //Battery Submit
  onSubmitBattery() {
    console.log(this.batteryForm);
    this.submitted = true;
    if (this.batteryForm.valid) {
      this.currentStep = 3;
    } else if (this.batteryForm.invalid) {
      console.log("invalid");
      return alertModalWithoutConfirm(
        "warning",
        "Please fill in all required fields before submitting."
      );
    }
  }

  //Warranty Info Invoice File upload
  imagePreviewUrl: string | ArrayBuffer | null = null;
  pdfPreviewUrl: SafeResourceUrl | null = null;
  filePreviewUrl: string | ArrayBuffer | null = null;
  fileName: string | null = null;
  onFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        if (file.type.includes("image")) {
          this.imagePreviewUrl = e.target.result;
          this.pdfPreviewUrl = null;
          this.filePreviewUrl = null;
        } else if (file.type.includes("pdf")) {
          this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            e.target.result
          );
          this.imagePreviewUrl = null;
          this.filePreviewUrl = null;
        } else if (
          file.type.includes("msword") ||
          file.type.includes("vnd.openxmlformats-officedocument.wordprocessingml.document") ||
          file.type.includes("vnd.ms-excel") ||
          file.type.includes("vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        ) {
          this.filePreviewUrl = e.target.result;
          this.imagePreviewUrl = null;
          this.pdfPreviewUrl = null;
        }
      };

      reader.readAsDataURL(file);

      // Update form control
      this.warrantyForm.patchValue({ invoice: file });
      this.warrantyForm.get("invoice")?.enable();

    } else {
      // Clear previews and form control if no file selected
      this.imagePreviewUrl = null;
      this.pdfPreviewUrl = null;
      this.filePreviewUrl = null;
      this.fileName = null;
      this.warrantyForm.patchValue({ invoice: null });
    }

    event.target.value = '';
  }


  //Formatted Expiry DATE
  formatExpiryDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }

  //Formatted Rented DATE
  formatRentedDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }

  navigateToStep(step: number): void {
    this.currentStep = step;
  }

  // Price Formatting
  formatCurrency(value: string | number): string {
    if (!value) return "";
    return new Intl.NumberFormat("en-IN").format(Number(value));
  }

  onProductCostInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/[^0-9]/g, "");
    this.productForm
      .get("productCost")
      ?.setValue(numericValue, { emitEvent: false });
    input.value = this.formatCurrency(numericValue);
  }

  blockNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  mainImageRequiredMessage = false;
  checkMainImageUploaded(event: Event): void {
    console.log("clicked");
    if (this.selectedImages.length === 0) {
      event.preventDefault();
      this.mainImageRequiredMessage = true;
      setTimeout(() => {
        this.mainImageRequiredMessage = false;
      }, 3000);
    }
  }

  // For edit mode
  newImages: File[] = [];

  onSelectImage(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const selectedImage = event.target.files[0];

      const totalImages = this.selectedImages.length + 1;
      if (totalImages > this.maxImages) {
        return alertModalWithoutConfirm(
          "warning",
          "You can only upload a maximum of 4 images."
        );
      }

      this.newImages = [selectedImage];
      this.selectedImages = [...this.selectedImages, ...this.newImages];

      this.updateImagePreviews();

      this.productForm.patchValue({
        productFile: this.selectedImages,
      });
      console.log("Selected images (including existing):", this.selectedImages);
    }
  }

  // Multiple Image Selection
  onSelectMultipleImages(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      const filesArray: File[] = Array.from(event.target.files) as File[];
      const totalImages = this.selectedImages.length + filesArray.length;

      if (totalImages > this.maxImages) {
        return alertModalWithoutConfirm(
          "warning",
          "You can only upload a maximum of 4 images."
        );
      }

      this.newImages = filesArray;
      this.selectedImages = [...this.selectedImages, ...this.newImages];

      this.selectedImages = Array.from(new Set(this.selectedImages));

      this.updateImagePreviews();
      this.productForm.patchValue({
        productFile: this.selectedImages,
      });
      console.log("Selected images (including existing):", this.selectedImages);
    }
  }

  // Preview Image Updates
  updateImagePreviews(): void {
    this.previewImagesUrl = [];
    this.selectedImages.forEach((image) => {
      if (typeof image === "string") {
        this.previewImagesUrl.push(image);
      } else {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewImagesUrl.push(e.target.result);
        };
        reader.readAsDataURL(image);
      }
    });
  }


  // Remove multiple uploaded images
  removeImage(index: number): void {
    const removedImage = this.selectedImages[index];
    const body = {
      inventoryId: this.editInventoryId,
      images: [removedImage],
    };

    this.inventoryService.deleteInventoryImage(body).subscribe(
      (response) => {
        console.log("Image removed successfully from server:", response);

        this.selectedImages.splice(index, 1);
        this.updateImagePreviews();
        this.productForm.patchValue({
          productFile: this.selectedImages,
        });
      },
      (error) => {
        console.error("Failed", error);
      }
    );
  }

  allformData: any = {};
  //Warranty Submit
  barcodeImageUrl: string;
  barcode: any;
  onSubmitWarranty() {
    console.log("isEdit value:", this.isEdit);

    if (
      this.productForm.valid &&
      this.batteryForm.valid &&
      this.warrantyForm.valid
    ) {
      const allFormValue = {
        ...this.productForm.value,
        ...this.batteryForm.value,
        ...this.warrantyForm.value,
      };

      this.allformData = allFormValue;
      console.log(allFormValue);
      5;

      const expiryDate = new Date(allFormValue.expiryDate);
      const formattedExpiryDate = this.formatExpiryDate(expiryDate);

      const rentedDate =
        allFormValue.type === "Rental"
          ? new Date(allFormValue.rentedDate)
          : null;
      const formattedRentedDate = rentedDate
        ? this.formatRentedDate(rentedDate)
        : null;

      const assignTo = (allFormValue.assignTo || [])
        .map((val: string) => {
          const user = this.users.find(u => u.value === val);
          return user ? { assigneeId: user.id, assigneeName: user.viewValue } : null;
        })
        .filter(Boolean);

      const trimmedProductId = (allFormValue.productId || "").trim();
      const getFormValue: any = {
        name: String(allFormValue.assetName || ""),
        assignTo,
        available: Boolean(allFormValue.available),
        cost: allFormValue.productCost || "",
        accessories: allFormValue.accessoriesInv
          ? allFormValue.accessoriesInv.split(",")
          : [],
        assetCategory: allFormValue.assetCategory || "",
        batteryType: allFormValue.batteryType || "",
        haveStorage: Boolean(allFormValue.storageType === "yes" ? true : false),
        // storageVolume: allFormValue.storageValue,
        haveWarranty: Boolean(allFormValue.warranty === "yes" ? true : false),

        location: String(allFormValue.location || ""),
        type: allFormValue.type,
        brand: String(allFormValue.brand || ""),
        size: allFormValue.size,
        quantity:
          allFormValue.quantity !== undefined
            ? Number(allFormValue.quantity)
            : 0,
      };

      if (!this.isEdit) {
        if (trimmedProductId) {
          getFormValue.productId = trimmedProductId;
        }
      } else {
        const original = (this.originalProductId || "").trim();
        if (trimmedProductId && trimmedProductId !== original) {
          getFormValue.productId = trimmedProductId;
        }
      }

      if (allFormValue.type === "Rental") {
        getFormValue.rentedTill = formattedRentedDate;
      }
      if (this.showRechargeCycle) {
        getFormValue.recharge = {
          number: allFormValue.recharge.number || 0,
          cycle: "days",
        };
      }
      if (this.isStorageEnabled) {
        getFormValue.storageVolume = allFormValue.storageValue;
      }
      if (this.isEdit && this.editInventoryId) {
        getFormValue.assetId = this.editInventoryId;
      }
      if (this.isWarrantyEnabled) {
        console.log(this.isWarrantyEnabled, "Abbbb");
        getFormValue.warranty = {
          expiry: formattedExpiryDate,
          contactPerson: allFormValue.contactPerson || "",
          phoneNumber: allFormValue.phoneNumber || "",
        };
      }
      const formData = new FormData();
      const appendFormData = (data: any, parentKey?: string) => {
        if (data && typeof data === "object" && !Array.isArray(data)) {
          Object.keys(data).forEach((key) => {
            appendFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
          });
        } else if (Array.isArray(data)) {
          data.forEach((item, index) => {
            appendFormData(item, `${parentKey}[${index}]`);
          });
        } else {
          if (parentKey === "cost") {
            formData.append(parentKey, String(data));
          } else if (parentKey) {
            formData.append(parentKey, data);
          }
        }
      };
      console.log(getFormValue, "values");
      appendFormData(getFormValue);

      const selectedImages = this.productForm.get("productFile")?.value;
      if (selectedImages && Array.isArray(selectedImages)) {
        let newIndex = 0;
        selectedImages.forEach(async (image: File | string) => {
          if (typeof image === "string") {
            const blob = await fetch(image).then((res) => res.blob());
            formData.append(`files[${newIndex}]`, blob, "blob");
          } else {
            formData.append(`files[${newIndex}]`, image, image.name);
          }
          newIndex++;
        });
      }

      // Append the invoice file
      const invoice = this.warrantyForm.get("invoice")?.value;
      if (invoice && invoice instanceof File) {
        formData.append("warrantyInvoice", invoice, invoice.name);
      }
      if (!this.isEdit) {
        this.isFormSubmitting = true;
        this.inventoryService.addInventory(formData).subscribe({
          next: (response: any) => {
            this.currentStep = 4;
            this.getInventoryData();
            this.barcode = response?.data?.barcode;
            this.assignedProductId = response?.data?.productId || trimmedProductId || "";
            this.isFormSubmitting = false;
            this.duplicateProductIdError = "";
            console.log(this.barcodeImageUrl, "QR code");
          },
          error: (error) => this.handleInventorySaveError(error)
        });
      } else {
        console.log("Updating");
        this.isFormSubmitting = true;
        this.inventoryService.updateInventory(formData).subscribe({
          next: (response: any) => {
            this.currentStep = 4;
            this.getInventoryData();
            this.barcode = response?.data?.barcode;
            this.assignedProductId =
              response?.data?.productId ||
              trimmedProductId ||
              this.originalProductId ||
              "";
            this.isFormSubmitting = false;
            this.duplicateProductIdError = "";
            alertModalWithoutConfirm("success", "Inventory updated successfully!");
            console.log(this.barcodeImageUrl, "QR code");
          },
          error: (error) => this.handleInventorySaveError(error)
        });
      }
    }
    console.log("One or more forms are invalid");
  }

  private handleInventorySaveError(error: any) {
    this.isFormSubmitting = false;
    console.error("error:", error);
    const message = this.extractErrorMessage(error?.error) || "Something went wrong!";
    // Only surface under the Product ID field when it's actually a duplicate ID
    if (error?.status === 409 || message.toLowerCase().includes("exist")) {
      this.duplicateProductIdError = message;
      this.currentStep = 1;
      alertModalWithoutConfirm("warning", message);
    } else {
      alertModalWithoutConfirm("error", message);
    }
  }

  // Backend may return message as a string, an array of strings, or a nested object
  private extractErrorMessage(value: any): string {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (Array.isArray(value)) {
      return value.map((v) => this.extractErrorMessage(v)).filter(Boolean).join(", ");
    }
    if (typeof value === "object") {
      return this.extractErrorMessage(value.message ?? value.msg ?? value.error ?? value.errors);
    }
    return String(value);
  }

  get selectedVisibleInventoryIds(): string[] {
    return this.inventory
      .map((item) => item?.assetId)
      .filter((id) => id && this.selectedInventoryIds.has(id));
  }

  get allInventorySelected(): boolean {
    return this.inventory.length > 0 && this.selectedVisibleInventoryIds.length === this.inventory.length;
  }

  toggleInventorySelection(id: string, checked: boolean) {
    if (checked) {
      this.selectedInventoryIds.add(id);
    } else {
      this.selectedInventoryIds.delete(id);
    }
  }

  toggleAllInventorySelection(checked: boolean) {
    this.selectedInventoryIds.clear();
    if (checked) {
      this.inventory.forEach((item) => item?.assetId && this.selectedInventoryIds.add(item.assetId));
    }
  }

  exportBarcodes() {
    if (this.isExportingBarcodes) return;
    this.isExportingBarcodes = true;
    this.inventoryService.exportInventoryBarcodes(this.selectedVisibleInventoryIds).subscribe({
      next: (blob) => {
        saveBlob(blob, "inventory-barcodes.xlsx");
        this.selectedInventoryIds.clear();
        this.isExportingBarcodes = false;
      },
      error: async (error) => {
        this.isExportingBarcodes = false;
        alertModalWithoutConfirm("error", await readBlobError(error));
      },
    });
  }

  //Download QR Code
  downloadbarcode() {
    const link = document.createElement("a");
    link.href = this.barcode;
    link.download = "qr-code.png";
    link.click();
  }

  //Print QR Code
  printbarcode() {
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
          </head>
          <body>
            <img src="${this.barcode}" alt="QR Code">
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() {
                  window.close();
                };
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    }
  }

  isEdit: boolean = false;
  previewProductImg: any;
  productDetail: any;
  openProductDetail(index: number) {
    this.isEdit = true;
    this.activeDetailTab = 'details';
    this.previewProductImg = this.inventory[index];
    this.productDetail = this.inventory[index];
    this.editInventoryId = this.inventory[index]?._id || this.inventory[index]?.assetId;
    console.log({ Product: this.productDetail });
  }

  resetClose() {
    this.productForm.reset();
    this.batteryForm.reset();
    this.warrantyForm.reset();

    this.currentStep = 1;
    this.duplicateProductIdError = "";
    this.originalProductId = "";
    this.assignedProductId = "";
    this.selectedImages = [];
    this.previewImagesUrl = [];
    this.imagePreviewUrl = null;
    this.pdfPreviewUrl = null;
    this.filePreviewUrl = null;

    this.warrantyForm.get('invoice')?.setValue(null);

    const fileInput = document.querySelector<HTMLInputElement>('input[formControlName="invoice"]');
    if (fileInput) fileInput.value = '';

    this.isEdit = false;
    const batteryTypeValue = this.batteryForm.get("batteryType")?.value;
    this.showRechargeCycle = batteryTypeValue === "Chargeable";
    if (!this.showRechargeCycle) {
      this.batteryForm.get("recharge")?.reset("");
    }
  }


  downloadInvoice(url: string) {
    window.open(url, "_blank");
  }

  download(url: string) {
    window.open(url, "_blank");
  }
  previewInventory: any;
  openPreviewSlider(index: number) {
    this.previewInventory = this.inventory[index];
    console.log("Preview Inventory", this.previewInventory);
  }

  previewMyAssigned: any;
  openMyAssignedSlider(index: number) {
    this.previewMyAssigned = this.ownAssigned[index];
    console.log("Preview My Assigned", this.previewMyAssigned);
  }

  previewAssigned: any;
  openAssignedSlider(index: number) {
    this.previewAssigned = this.assigned[index];
    console.log("Preview Assigned", this.previewAssigned);
  }

  currentPageNume: number = 1;
  onScroll() {
    if (!this.isAssigned && !this.myAssigned) {
      console.log("Scrolled! Current Inventory Length:", this.inventory.length);
      const totalLoaded = this.inventory.length;
      if (totalLoaded >= this.totalInventory) return;
      this.currentPageNume++;
      this.getInventoryData();
    }

    if (this.isAssigned) {
      const totalLoaded = this.assigned.length;
      if (totalLoaded >= this.totalAssigned) return;
      this.currentPageNume++;
      this.getAssignedInventory();
    }

    if (this.myAssigned) {
      console.log("Scrolled! Current Assigned Length", this.ownAssigned.length);
      const totalLoaded = this.ownAssigned.length;
      if (totalLoaded >= this.totalMyAssigned) return;
      this.currentPageNume++;
      this.getOnlyAssignedInventory();
    }
  }

  loggedInUsername = localStorage.getItem("username");
  inventory: any[] = [];
  totalInventory: number = 0;
  inventoryAccessory: any;
  barCodeImg: any;
  searchQuery: string;
  isAllInventory: boolean = false;
  currentLimit: number = 100;
  isFetchingInventory: boolean = false;

  getInventoryData(reset = false, assignedToUser?: string) {
    if (reset) {
      this.currentPageNume = 1;
      this.inventory = [];
    }

    const targetUser =
      assignedToUser ||
      (this.selectedFilter !== 'all' &&
        this.selectedFilter !== 'assigned' &&
        this.selectedFilter !== 'onlyAssigned'
        ? this.selectedFilter
        : undefined);

    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      searchQuery: this.searchQuery,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
    };

    if (targetUser) {
      field.assignedTo = targetUser;
    } else {
      field.available = true;
    }

    this.inventoryService.getAllInventory(field).subscribe((response: any) => {
      const newItems = response?.data?.records || [];

      if (this.currentPageNume === 1) {
        this.inventory = [...newItems];
      } else {
        this.inventory = [...this.inventory, ...newItems];
      }

      this.totalInventory = response?.data?.totalCounts || 0;
      this.isAllInventory = true;
      this.isAssigned = false;
      this.myAssigned = false;
      this.isShimmerLoading = false;
    });
  }




  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  searchedInventory = [];
  totalSearchedInv: any;
  onSearchInventory() {
    const targetUser =
      this.selectedFilter !== 'all' &&
        this.selectedFilter !== 'assigned' &&
        this.selectedFilter !== 'onlyAssigned'
        ? this.selectedFilter
        : undefined;

    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalInventory || 50,
      searchQuery: this.searchQuery,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
    };

    if (targetUser) {
      field.assignedTo = targetUser;
    } else {
      field.available = true;
    }

    if (this.searchQuery === "") {
      this.clearSearch();
    } else {
      this.inventoryService
        .getSearchedInventory(field)
        .subscribe((response: any) => {
          console.log(response);
          this.searchedInventory = response?.["data"]?.records || [];
          this.inventory = this.searchedInventory;
          this.totalSearchedInv = response?.["data"]?.totalCounts || 0;
          this.totalInventory = this.totalSearchedInv;
        });
    }
  }

  clearSearch() {
    this.searchQuery = "";
    this.searchedInventory = [];
    this.inventory = [];
    this.currentPageNume = 1;
    this.getInventoryData();
  }

  getAllUsers(): void {
    const loggedInUsername = localStorage.getItem("username");
    const loggedInUserId = localStorage.getItem("guestID");
    this.inventoryService.getInvUsers().subscribe(
      (res) => {
        let data = res["data"] || [];
        this.users = data.map((user: any) => ({
          value: user.userName,
          viewValue: user.userName,
          id: user._id,
        }));
        console.log("users", this.users);
        if (loggedInUsername && loggedInUserId) {
          const alreadyExists = this.users.some(
            (u) => u.id === loggedInUserId || u.value === loggedInUsername
          );
          if (!alreadyExists) {
            this.users.push({
              value: loggedInUsername,
              viewValue: loggedInUsername,
              id: loggedInUserId,
            });
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  assignInventory(users: any, inventories: any) {
    console.log({ users, inventories });

    const assignData = {
      userName: users?.value,
      userId: users?.id,
      assetId: inventories?.assetId,
      redirectUrl: `${environment.redirectUrl}#/inventory/inventories?filter=onlyAssigned`,
    };
    this.inventoryService.assignInv(assignData).subscribe((response) => {
      console.log("assigned called");
      this.getInventoryData();
    });
  }


  onDeleteAssignedInv(id: string): void {
    alertModalDelete("You won't be able to revert this!").then((isConfirmed) => {
      if (isConfirmed) {
        this.inventoryService.deleteAssignedInv(id).subscribe({
          next: (response) => {
            console.log('Assigned inventory deleted:', response);
            this.assigned = this.assigned.filter(item => item.assignedInventoryId !== id);

          },
          error: (err) => {
            console.error('Failed to delete assigned inventory:', err);
            const message = err?.error?.message || "Something went wrong!";
            alertModalDelete(message);
          }
        });
      } else {
        alertModalDelete("Deletion cancelled");
      }
    });
  }

}
